export default __webpack_public_path__ + "static/media/Beppe3.557721bf.jpg";